import _ from 'lodash';

import React, { useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { SLIDESHOWMODALSTEP } from 'config/constants';
import SlideshowPictures from './SlideshowPictures';
import SlideshowTemplates from './SlideshowTemplates';
import SlideshowSummary from './SlideshowSummary';

const useStyles = makeStyles({
  stepContent: {
    flex: '1 1',
    display: 'flex',
    flexDirection: 'column',
    padding: '2px 0',
    overflow: 'hidden',

    '& .ScrollView': {
      flex: '1 1',
      maxHeight: 500,
      overflow: 'hidden auto',
      padding: 5,
    },

    '& .ButtonsBox': {
      height: 35,
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: 20,

      '& .MuiButton-root': {
        textTransform: 'capitalize',
      },

      '& .BackButton': {
        marginRight: 20,
      },

      '& .Hidden': {
        visibility: 'hidden',
      },
    },

    '& h1': {
      fontWeight: 700,
      textAlign: 'center',
      textTransform: 'capitalize',
    },

    '& .FlexBox': {
      position: 'relative',
      width: '100%',
      marginTop: 20,

      '&:first-child': {
        marginTop: 0,
      },

      '&.NoMargin': {
        marginTop: 0,
      },

      '&.Vertical .InfoItem_Label': {
        width: 'auto',
        marginRight: 0,
      },
    },

    '& .InfoItem_Label': {
      width: 150,
      fontWeight: 600,
      textTransform: 'capitalize',
      marginRight: 10,
    },

    '& .InfoItem_Value': {
      flex: 1,
    },

    '& input': {
      padding: '10px 15px',
    },

    '& hr': {
      width: '100%',
    },

    '& .SaveButtonBox': {
      display: 'flex',
      justifyContent: 'center',
      padding: '20px 0',

      '& button': {
        width: 120,
        textTransform: 'none',
      },
    },
  },
  slideshowModalStepper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
});
interface Props {
  onClose: () => void;
}

function SlideshowModalStepper({ onClose }: Props) {
  const styles = useStyles();

  const initialStep = 0;
  const [activeStep, setActiveStep] = useState(initialStep);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedPictures, setSelectedPictures] = useState([]);
  const [picturesWithNewOrder, setPicturesWithNewOrder] = useState([]);

  const stepContent = () => {
    switch (activeStep) {
      case SLIDESHOWMODALSTEP.TEMPLATES:
        return (
          <SlideshowTemplates
            key={0}
            setActiveStep={setActiveStep}
            selectedTemplate={selectedTemplate}
            setSelectedTemplate={setSelectedTemplate}
          />
        );
      case SLIDESHOWMODALSTEP.PICTURES:
        return (
          <SlideshowPictures
            key={1}
            setActiveStep={setActiveStep}
            setSelectedPictures={setSelectedPictures}
            selectedTemplate={selectedTemplate}
            selectedPictures={selectedPictures}
            picturesWithNewOrder={picturesWithNewOrder}
            setPicturesWithNewOrder={setPicturesWithNewOrder}
          />
        );
      default:
        return (
          <SlideshowSummary
            key={2}
            setActiveStep={setActiveStep}
            selectedTemplate={selectedTemplate}
            picturesWithNewOrder={picturesWithNewOrder}
          />
        );
    }
  };

  return (
    <Box className={styles.slideshowModalStepper}>
      <Box className={styles.stepContent}>{stepContent()}</Box>
    </Box>
  );
}

SlideshowModalStepper.defaultProps = {
  onClose: _.noop,
};

SlideshowModalStepper.propTypes = {
  onClose: PropTypes.func,
};

export default SlideshowModalStepper;
